/**
* 供货管理 供货发票管理
*/
<template>
  <div class="contianer">
    <!-- 订单提现 -->
    <div class="mt20">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我供货的" name="first">
          <el-form :inline="true" :model="formInline" class="user-search">
            <el-date-picker
              v-model="searchDate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-form-item label="">
              <el-select v-model="formInline.invoice_status" placeholder="请选择开票状态" clearable>
                <el-option label="开票中" value="1653"></el-option>
                <el-option label="已开票" value="1651"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.apply_no" placeholder="发票申请单号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search">查询</el-button>
              <el-button size="small" type="primary" plain @click="sortDialog">开票记录</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick"
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="申请时间" width="150">
                <template slot-scope="scope">
                  <div>{{scope.row.create_time|timestampToTime}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="apply_no" label="发票申请单号" width="160">
              </el-table-column>
              <el-table-column prop="invoice_maker" label="开票方" min-width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="withdraw_code" label="单据号" width="220" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoice_title" label="发票抬头" min-width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="invoicable_money" label="发票金额" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.invoicable_money}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoice_type" label="发票类型" width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.invoice_type=='182'">增值税专用发票</div>
                  <div v-else-if="scope.row.invoice_type=='181'">增值税电子发票</div>
                  <div v-else-if="scope.row.invoice_type=='180'">增值税普通发票</div>
                  <div v-else-if="scope.row.invoice_type=='183'">全电发票(专用发票)</div>
                  <div v-else-if="scope.row.invoice_type=='184'">全电发票(普通发票)</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoice_status" label="开票状态" width="100">
                <template slot-scope="scope">
                  <div plain style="color: #E6A23C" v-if="scope.row.invoice_status=='1653'">
                    开票中
                  </div>
                  <div plain style="color: #F56C6C" v-else-if="scope.row.invoice_status=='1650'">
                    待开票
                  </div>
                  <div plain style="color: #409eff" v-else>
                    已开票
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="134">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini"
                             @click="detailApply(scope.row.id,)">
                    开票
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-tab-pane>

        <!-- 给我供货 -->
        <el-tab-pane label="给我供货" name="second" v-if="agent_type=='2891'">
          <el-form :inline="true" :model="formInline1" class="user-search">
            <el-date-picker
              v-model="searchDate1"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-form-item label="">
              <el-select v-model="formInline1.invoice_status" placeholder="请选择供应商名称" clearable>
                <el-option label="开票中" value="1653"></el-option>
                <el-option label="已开票" value="1651"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search1">查询</el-button>
              <el-button size="small" type="warning" @click="serviceDialog">申请开票</el-button>
              <el-button size="small" type="primary" plain @click="sortDialog">开票记录</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                      element-loading-text="拼命加载中" style="width: 80%;">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="申请时间" width="150">
                <template slot-scope="scope">
                  <div>{{scope.row.create_time|timestampToTime}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="seller_name" label="供应商名称" min-width="160" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="record_code" label="单据号" width="220" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="settle_amount" label="供应商提现金额（元）" width="180" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.settle_amount}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="invoice_amount" label="可开票金额（元）" width="180" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.invoice_amount}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="bill_type" label="开票状态" width="100">
                <template slot-scope="scope">
                  <div plain style="color: #E6A23C" v-if="scope.row.bill_type=='1653'">
                    开票中
                  </div>
                  <div plain style="color: #F56C6C" v-else-if="scope.row.bill_type=='1650'">
                    待开票
                  </div>
                  <div plain style="color: #409eff" v-else>
                    已开票
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
        </el-tab-pane>
      </el-tabs>
      <!-- 添加发票-->
      <el-dialog :visible.sync="recordInvoiceVisible" title="添加发票"
                 :close-on-click-modal="false" :close-on-press-escape="false" width="55%" top="7vh" center>
        <p class="voicetitle">开票金额</p>
        <el-table size="small" :data="ordeSendData"
                  highlight-current-row v-loading="loading" border show-summary
                  :summary-method="getSummaries"
                  element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 5px">
          <el-table-column
            type="index"
            label="序号"
            width="50">
            <template slot-scope="scope">
              {{pageSize * (currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="单据创建时间" min-width="150">
          </el-table-column>
          <el-table-column prop="withdraw_code" label="单据号" min-width="200">
          </el-table-column>
          <el-table-column prop="fee" label="供应商提现金额（元）" min-width="180">
            <template slot-scope="scope">
              <div>￥{{scope.row.fee}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="invoicable_money" label="可开票金额（元）" min-width="180">
            <template slot-scope="scope">
              <div>￥{{scope.row.invoicable_money}}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ordeSendData.length"
          >
          </el-pagination>
          <div style="color: #D9001B;">合计可开票金额小于5000元，不能开票，请重新选择</div>
        </div>
        <div class="billing_information" style="margin-bottom: 20px">
          <p class="voicetitle" style="margin-top: 10px">开票信息</p>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">发票抬头</p>
              <span class="f14 color333">{{invoiceData.invoice_title}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">纳税人识别号</p>
              <span class="f14 color333">{{invoiceData.taxpayer_no}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">开户银行</p>
              <span class="f14 color333">{{invoiceData.bank_name}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">开户银行账号</p>
              <span class="f14 color333">{{invoiceData.bank_account}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">注册地址</p>
              <span class="f14 color333">{{invoiceData.enterprise_address}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">注册电话</p>
              <span class="f14 color333">{{invoiceData.enterprise_tel}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">发票内容</p>
              <span class="f14 color333">{{invoiceData.invoice_detail}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">电子邮箱</p>
              <span class="f14 color333">{{invoiceData.invoice_detail}}</span>
            </div>
          </div>
        </div>
        <p class="voicetitle">发票信息</p>
        <el-form label-width="120px" :model="invoiceForm" :rules="invoiceFormrules" ref="invoiceForm" class="delivery">
          <el-form-item label="发票代号" prop="invoice_no">
            <el-input size="small" v-model="invoiceForm.invoice_no" auto-complete="off" placeholder="请输入发票代号"
                      maxLength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="发票号" prop="invoice_code">
            <el-input size="small" v-model="invoiceForm.invoice_code" auto-complete="off" placeholder="请输入发票号"
                      maxLength="40" clearable></el-input>
          </el-form-item>
          <el-form-item label="开票金额" prop="invoice_money">
            <el-input size="small" v-model="invoiceForm.invoice_money" auto-complete="off" clearable disabled="disabled"
                      placeholder="请输入开票金额" maxLength="10"></el-input>
          </el-form-item>
          <el-form-item label="税率" prop="tax_rate" class="relative">
            <el-input size="small" v-model="invoiceForm.tax_rate" auto-complete="off" placeholder="请输入税率"></el-input>
            <span class="absolute percentage">%</span>
          </el-form-item>
          <el-form-item label="开票日期" prop="invoice_date">
            <el-date-picker
              v-model="invoiceForm.invoice_date"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发票类型" prop="invoice_type">
            <el-select v-model="invoiceForm.invoice_type" placeholder="请选择发票类型" clearable @change="changeType">
              <el-option label="增值税专用发票" value="182"></el-option>
              <el-option label="增值税普通发票（电子发票）" value="181"></el-option>
              <el-option label="增值税普通发票（纸质发票）" value="180"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电子发票上传" prop="pdf_url" v-if="invoiceForm.invoice_type==181">
            <div v-if = "invoiceForm.pdf_url">
              <div class="float-left" v-for="(video,index) in productPdfUrl" :key="index">
                <div class="video-list-box" @mouseenter="handleMouseEnter(video.isShowButton,index)"
                     @mouseleave="handleMouseLeave(video.isShowButton,index)">
                  <div class="img-mask" v-show="video.isShowButton">
                    <div class="inline_block">
                      <el-upload
                        class="avatar-uploader"
                        action="#"
                        :show-file-list="false"
                        :http-request="uploadFile"
                        :before-upload="uploadDefaultUpload"
                      >
                      </el-upload>
                    </div>
                    <i class="el-icon-zoom-in" @click="lookInvoice"></i>
                    <i class="el-icon-delete" @click="delPdf(index)"></i>
                  </div>
                  <el-image class="inline_block video-default-img"
                            :src="video.img_url?video.img_url:defaultVideoImg">
                  </el-image>
                </div>
              </div>
            </div>
            <div v-else>
              <el-upload list-type="picture-card" :http-request="uploadFile" ref="upload1"
                         v-loading.fullscreen.Tock="videoloading"
                         element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading"
                         element-loading-background="rgba(0,0,0,0.8)"
                         class="avatar-uploader float-left avatar-uploader el-upload--text upload_btn" action="#" :show-file-list="false"
                         :file-list="productPdfFilesList"
                         :before-upload="beforeUploadPdf"
                         :on-success="handleSuccess"
                         :auto-upload="true"
                         :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="note"><span>仅能上传pdf文件，文件大小限制为最大20M</span></div>
          </el-form-item>
          <el-form-item label="快递公司" prop="deliver_comp" v-if="invoiceForm.invoice_type!=181">
            <el-select v-model="invoiceForm.deliver_comp" filterable placeholder="请选择" clearable
                       @change="deliverChange(invoiceForm.deliver_comp)">
              <el-option
                v-for="item in popularDeliveryListData"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="delivery_no" v-if="invoiceForm.invoice_type!=181">
            <el-input size="small" v-model.trim="invoiceForm.delivery_no" auto-complete="off" placeholder="请输入快递单号"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="电子发票上传" prop="pdf_url" v-if="invoiceForm.invoice_type==180 || invoiceForm.invoice_type==182">
            <div v-if = "invoiceForm.pdf_url">
              <div class="float-left" v-for="(video,index) in productPdfUrl" :key="index">
                <div class="video-list-box" @mouseenter="handleMouseEnter(video.isShowButton,index)"
                     @mouseleave="handleMouseLeave(video.isShowButton,index)">
                  <div class="img-mask" v-show="video.isShowButton">
                    <div class="inline_block">
                      <el-upload
                        class="avatar-uploader"
                        action="#"
                        :show-file-list="false"
                        :http-request="uploadFile"
                        :before-upload="uploadDefaultUpload"
                      >
                      </el-upload>
                    </div>
                    <i class="el-icon-zoom-in" @click="lookInvoice"></i>
                    <i class="el-icon-delete" @click="delPdf(index)"></i>
                  </div>
                  <el-image class="inline_block video-default-img"
                            :src="video.img_url?video.img_url:defaultVideoImg">
                  </el-image>
                </div>
              </div>
            </div>
            <div v-else>
              <el-upload list-type="picture-card" :http-request="uploadFile" ref="upload1"
                         v-loading.fullscreen.Tock="videoloading"
                         element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading"
                         element-loading-background="rgba(0,0,0,0.8)"
                         class="avatar-uploader float-left avatar-uploader el-upload--text upload_btn" action="#" :show-file-list="false"
                         :file-list="productPdfFilesList"
                         :before-upload="beforeUploadPdf"
                         :on-success="handleSuccess"
                         :auto-upload="true"
                         :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="note"><span>仅能上传pdf文件，文件大小限制为最大20M</span></div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="recordInvoiceVisible=false">关 闭</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title"
                     @click="submitInvoiceForm('invoiceForm')">保 存
          </el-button>
        </div>
      </el-dialog>

      <!-- 开票申请-->
      <el-dialog :visible.sync="serviceInvoiceVisible" title="开票申请"
                 :close-on-click-modal="false" :close-on-press-escape="false" width="55%" top="7vh" center>
        <p class="voicetitle">开票金额</p>
        <el-table size="small" :data="InvoicineData.slice((servieCurrentPage - 1) * serviePageSize, servieCurrentPage * serviePageSize)"
                  highlight-current-row v-loading="loading" border show-summary
                  :summary-method="getRecordSummaries"
                  element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 5px">
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column prop="create_time" label="单据创建时间" width="150">
          </el-table-column>
          <el-table-column prop="withdraw_code" label="单据号" min-width="200">
          </el-table-column>
          <el-table-column prop="fee" label="供应商提现金额（元）" width="180">
            <template slot-scope="scope">
              <div>￥{{scope.row.fee}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="invoicable_money" label="可开票金额（元）" width="180">
            <template slot-scope="scope">
              <div>￥{{scope.row.invoicable_money}}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block">
          <el-pagination
            background
            @size-change="servieHandleSizeChange"
            @current-change="servieHandleCurrentChange"
            :current-page="servieCurrentPage"
            :page-sizes="[10, 20, 30]"
            :page-size="serviePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="InvoicineData.length"
          >
          </el-pagination>
          <div style="color: #D9001B;">合计可开票金额小于5000元，不能开票，请重新选择</div>
        </div>
        <div class="billing_information" style="margin: 20px 0">
          <p class="voicetitle">发票信息</p>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">发票抬头</p>
              <span class="f14 color333">{{invoiceData.invoice_title}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">纳税人识别号</p>
              <span class="f14 color333">{{invoiceData.taxpayer_no}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">开户银行</p>
              <span class="f14 color333">{{invoiceData.bank_name}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">开户银行账号</p>
              <span class="f14 color333">{{invoiceData.bank_account}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">注册地址</p>
              <span class="f14 color333">{{invoiceData.enterprise_address}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">注册电话</p>
              <span class="f14 color333">{{invoiceData.enterprise_tel}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">发票内容</p>
              <span class="f14 color333">{{invoiceData.invoice_detail}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">邮寄地址</p>
              <span class="f14 color333">{{invoiceData.addr}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="flex_box billing_item">
              <p class="label f14 color666">电子邮箱</p>
              <span class="f14 color333">{{invoiceData.email}}</span>
            </div>
          </div>
        </div>
        <p class="voicetitle">发票信息</p>
        <el-form label-width="120px" :model="invoiceForm" :rules="invoiceFormrules" ref="invoiceForm" class="delivery">
          <el-form-item label="发票类型" prop="invoice_type">
            <el-select v-model="invoiceForm.invoice_type" placeholder="请选择发票类型" clearable @change="changeType()">
              <el-option label="增值税专用发票" value="181"></el-option>
              <el-option label="增值税普通发票（电子发票）" value="182"></el-option>
              <el-option label="增值税专用发票（纸质发票）" value="183"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮寄地址" prop="address" v-if="invoiceForm.invoice_type == 181 || invoiceForm.invoice_type == 183">
            <el-select v-model="invoiceForm.address" placeholder="请选择邮寄地址" clearable>
              <el-option v-for="email in emailData" :key="email.id" :label="email.email"
                         :value="email.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="invoice_email_id" v-if="invoiceForm.invoice_type == 182">
            <el-select v-model="invoiceForm.invoice_email_id" placeholder="请选择电子邮箱" clearable>
              <el-option v-for="email in emailData" :key="email.id" :label="email.email"
                         :value="email.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="serviceInvoiceVisible=false">关 闭</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title"
                     @click="invoiceLabel('invoiceForm')">保 存
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  addFinanceInvoice,
  applyList,
  emailList,
  financeDetail,
  setLabel,
  toMeList,
  supplyTitle,
  invoiceApply
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate, timestampToMonth, uploadFile} from "../../utils/util";
  import {getToken} from "../../api/commonMG";

  export default {
    data: () => {
      return {
        loading: false, // 是显示加载
        recordInvoiceVisible: false,
        serviceInvoiceVisible: false,
        searchDate: '',
        searchDate1: '',
        invoiceData: {},
        popularDeliveryListData: [],
        InvoicineData: [],
        emailData: [],
        formInline: {
          page: 1,
          rows: 10,
          supply_seller_id: "",
          begin_time: "",
          end_time: "",
          ref_ids: []
        },
        formInline1: {
          page: 1,
          rows: 10,
          // supply_seller_id: '',
          // begin_time: '',
          // end_time: '',
          // ref_ids: []
        },
        invoiceForm: {
          id: "",
          ref_ids: [],
          invoice_type: '',
          address: '',
          invoice_email_id: "",
        },
        ref_ids: '',
        activeName: 'first',
        listData: [], //用户数据
        listData1: [], //用户数据
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        servieCurrentPage: 1, // 当前页码
        serviePageSize: 10, // 每页的数据条数
        ordeSendData: [],
        selectTableData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        // rules表单验证
        rules: {
          seller_name: [{required: true, message: '请输入店铺名称', trigger: 'blur'}],
          agentType: [{required: true, message: '请选择供货身份', trigger: 'blur'}]
        },
        invoiceFormrules: {
          invoice_type: [{required: true, message: '请选择发票类型', trigger: 'blur'}],
          address: [{required: true, message: '请选择邮寄地址', trigger: 'blur'}],
          invoice_email_id: [{required: true, message: '请选择电子邮箱', trigger: 'blur'}],
        },
        agent_type: localStorage.getItem('agent_type')||'2891',
        videoloading: false,
        productPdfFilesList: [],
        productPdfUrl: [],
        imgUrl: '',
        form: {
          image: ''
        },
        defaultVideoImg: '/static/img/pdf.png'
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getData(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      lookInvoice() {
        window.open(this.invoiceForm.pdf_url)
      },
      // 获取公司列表1-0
      getData() {
        this.loading = true
        applyList(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getData(this.formInline)
      },
      // 获取公司列表1-1
      getData1() {
        this.loading = true
        toMeList(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData1 = res.content.rows
              // 分页赋值
              this.pageparm1.currentPage = this.formInline1.page
              this.pageparm1.pageSize = this.formInline1.rows
              this.pageparm1.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.rows = parm.pageSize
        this.getData1(this.formInline1)
      },
      // 搜索事件
      search() {
        if (this.formInline.searchDate) {
          this.formInline.begin_time = timestampToDate(this.searchDate[0])
          this.formInline.end_time = timestampToDate(this.searchDate[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getData(this.formInline)
      },
      search1() {
        if (this.formInline1.searchDate1) {
          this.formInline1.begin_time = timestampToDate(this.searchDate1[0])
          this.formInline1.end_time = timestampToDate(this.searchDate1[1])
        } else {
          this.formInline1.begin_time = ''
          this.formInline1.end_time = ''
        }
        this.formInline1.page = 1;
        this.getData1(this.formInline1)
      },
      handleClick(tab, event) {
        console.log(tab.index)
        if (tab.index == 0) {
          this.getData(this.formInline)
        } else if (tab.index == 1) {
          this.getData1(this.formInline1)
        }
      },
      // 开票-添加发票
      detailApply() {
        this.recordInvoiceVisible = true;
        financeDetail()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.orderTable = res.content
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 快递公司
      deliverChange(name) {
        this.popularDeliveryListData.forEach((item) => {
          if (item.name == name) {
            this.invoiceForm.deliver_comp_id = item.id
          }
        })
      },
      // 发票类型
      changeType() {
        this.$nextTick(() => {
          this.$refs["invoiceForm"].clearValidate(['pdf_url', 'deliver_comp', 'delivery_no']);
        });
      },
      // 保存添加发票
      submitInvoiceForm(formName) {
        if (this.invoiceForm.invoice_money > this.apply_invoice_money) {
          this.$message.error('开票金额不能大于申请开票金额!');
          return
        }
        this.invoiceForm.id = this.id;
        this.invoiceForm.delivery_no = this.invoiceForm.delivery_no
        if (!this.checkDate(this.invoiceForm.invoice_date)) {
          this.invoiceForm.invoice_date = timestampToDate(this.invoiceForm.invoice_date)
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            addFinanceInvoice(this.invoiceForm)
              .then(res => {
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                  this.getdata(this.formInline)
                  this.recordInvoiceVisible = false;
                }
              })
              .catch(err => {
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            return false;
          }
        });
      },
      // 申请开票
      serviceDialog() {
        // if (this.selectTableData.length == 0) {
        //   this.$message.error('请至少选择一条数据再操作!');
        //   return
        // }
        // const firstSeller = this.selectTableData[0].apply_no;
        // let isSameSeller = true;
        // for (let i = 1; i < this.selectTableData.length; i++) {
        //   if (this.selectTableData[i].apply_no!== firstSeller) {
        //     isSameSeller = false;
        //     break;
        //   }
        // }
        // if (!isSameSeller) {
        //   this.$message.error('只能选择同一个供货商申请开票');
        //   return;
        // }
        this.invoiceForm.ref_ids = [];
        this.invoiceForm = {};
        this.labelDialogVisible = true;
        // this.invoiceForm.ref_ids = this.selectTableData[0].ref_ids;
        this.InvoicineData = this.selectTableData;
        this.serviceInvoiceVisible = true
        supplyTitle()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.invoiceData = res.content;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        this.getEmail()
      },
      // 申请开票-保存
      invoiceLabel() {
        this.invoiceForm.ref_ids = [];
        this.selectTableData.forEach((item) => {
          this.invoiceForm.ref_ids.push(item.ref_ids)
        })
        this.loading = true;
        setLabel(this.invoiceForm)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功提交开票申请!'
              })
              this.labelDialogVisible = false;
              this.getData1(this.formInline1)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //获取邮箱
      getEmail() {
        let data = {
          page: 1,
          rows: 1000,
          id: '',
          email: ''
        };
        emailList(data)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.emailData = res.content.rows;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      handleSuccess(response, file, fileList) {
        this.upload_btn = true;
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      //每页条数改变时触发 选择一页显示多少行
      servieHandleSizeChange() {
        console.log(`每页 ${val} 条`);
        this.servieCurrentPage = 1;
        this.serviePageSize = val;
      },
      //当前页改变时触发 跳转其他页
      servieHandleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.servieCurrentPage = val;
      },
      // 总计
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      // 开票金额合计
      getRecordSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      uploadFile(file) {
      },
      delPdf(i) {
        this.productPdfUrl.forEach((item) => {
          this.productPdfUrl.splice(i, 1)
        })
        this.invoiceForm.pdf_url = ''
      },
      handleMouseLeave(isShowButton, i) {
        this.productPdfUrl[i].isShowButton = false;
      },
      handleMouseEnter(isShowButton, i) {
        this.videoDefaultImgIndex = i;
        this.productPdfUrl[i].isShowButton = true;
      },
      uploadDefaultUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
          return false
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB!");
          return false
        }
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          let width = '';
          let height = '';
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.productPdfUrl[this.videoDefaultImgIndex].img_url = res.data.content.file.fileUrl
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          this.$message({
            type: 'warning',
            message: '上传图片的尺寸应为500*500,当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            duration: 2000
          });
          return Promise.reject()
          return false;//必须加上return false; 才能阻止
        })
        return isSize;
      },
      beforeUploadPdf(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (file.type.indexOf('pdf') == -1) {
          this.$message.error('请上传正确的PDF格式');
          return false;
        }
        if (!isLt20M) {
          this.$message.error('上传pdf大小不能超过20MB哦!');
          return false;
        }
        let that = this
        this.videoloading = true;
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
              let data = {
                img_id: "",
                pdf_url: res.data.content.file.fileUrl,
                img_url: '',
                isShowButton: false
              }
              this.videoloading = false;
              that.invoiceForm.pdf_url = res.data.content.file.fileUrl;
              this.productPdfUrl.push(data)
            })
          }
        });
      },
      // 开票记录
      sortDialog() {
        localStorage.setItem('path', '/supply/supplyRecords')
        let tag = {
          url: "/supply/supplyRecords",
          menuname: "开票记录"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push('/supply/supplyRecords')
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.standard_code == cell.innerText || row.seller_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  };
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  .mt20 {
    margin-top: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .voicetitle {
    font-size: 20px;
    color: #66B1FF;
    margin-bottom: 10px;
  }

  .flex_box {
    display: flex;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 340px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }

  .delivery {
    margin-bottom: 10px;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-input--small {
    width: 220px;
  }

  .note {
    margin-top: 50px;
  }

  .note span {
    margin-left: 10px;
    font-size: 12px;
    color: #D9001B;
    line-height: 20px;
    text-align: left;
  }

  .absolute {
    position: absolute;
  }

  .percentage {
    left: 200px;
  }

  .block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader {
    height: 146px;
  }

  .video-list-box {
    width: 146px;
    height: 146px;
    margin-right: 10px;
    margin-bottom: 20px;
    border-radius: 6px;
    position: relative
  }

  .img-mask {
    width: 146px;
    height: 146px;
    line-height: 146px;
    background: #000;
    opacity: 0.6;
    position: absolute;
    z-index: 99;
    text-align: center;
    border-radius: 6px;
  }

  .img-mask i {
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/supply/supplyInvoice.vue